// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAvhj2vxUN0fGtdDBDnpqjCgxqECvSUfRY",
    authDomain: "avisacar-develop.firebaseapp.com",
    databaseURL: "https://avisacar-develop.firebaseio.com",
    projectId: "avisacar-develop",
    storageBucket: "avisacar-develop.appspot.com",
    messagingSenderId: "631863338069",
    appId: "1:631863338069:web:e9a51478ad3d5d81dc60dc"
  },
  app: {
    vehiclePath:"/assets/images/vehicles-type/",
    incidentPath:"./assets/images/incidents-type/",
    mailto:"mailto:test@gmail.com"
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
